import { getCurrentUser, getAuthHeader, API_BASE_URL } from './base';
import toast from "react-hot-toast";

export const createOnboarding = async () => {
  try {
    const user = await getCurrentUser();
    if (!user) throw new Error("No authenticated user");

    const token = await user.getIdToken();

    const response = await fetch(`${API_BASE_URL}/api/onboarding`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating onboarding:", error);
    return null;
  }
};
export const createFreeSubscription = async () => {
  try {
    const user = await getCurrentUser();
    if (!user) throw new Error("No authenticated user");

    const token = await user.getIdToken();

    const response = await fetch(
      `${API_BASE_URL}/api/stripe/create-free-subscription`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
    toast.error("Error creating free subscription");
    console.error("Error creating free subscription:", error);
  }
};
export const getCurrentSubscription = async (workspaceId = null) => {
  try {
    const user = await getCurrentUser();
    if (!user) throw new Error("No authenticated user");

    let url = `${API_BASE_URL}/api/stripe/current-subscription`;
    if (workspaceId) {
      url += `?workspaceId=${workspaceId}`;
    }

    const headers = await getAuthHeader();
    headers["Content-Type"] = "application/json";

    const response = await fetch(url, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Server response:", errorText);
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error getting subscription:", error);
    return null;
  }
};
export const getOnboarding = async () => {
  try {
    const user = await getCurrentUser();
    if (!user) throw new Error("No authenticated user");

    const token = await user.getIdToken();

    const response = await fetch(`${API_BASE_URL}/api/onboarding`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Server response:", errorText);
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();

    const onboardingObject = data.onboarding || { isCompleted: true };
    return onboardingObject;
  } catch (error) {
    console.error("Error getting onboarding:", error);
    return { isCompleted: true };
  }
};

export const updateOnboarding = async (
  currentStep,
  isCompleted = false,
  surveyId,
  { goal, goalOther } = {}
) => {
  try {
    const user = await getCurrentUser();
    if (!user) throw new Error("No authenticated user");

    const token = await user.getIdToken();

    const response = await fetch(`${API_BASE_URL}/api/onboarding`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ currentStep, isCompleted, surveyId, goal, goalOther }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Server response:", errorText);
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating onboarding:", error);
    return null;
  }
};
